import React from 'react';
import { PageTitle } from '@/_metronic/layout/core'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder';
import { TrafficEvolutionCard, TrafficRepartitionCard } from './components/cards/TrafficCard';

import { Indicators } from './components/Indicators';
import { TopPagesCard, TopReferrerCard } from './components/cards/TopCard';
import EnvironmentWrapper from './components/EnvironmentWrapper';

const Breadcrumbs = BreadcrumbsBuilder([
  { title: 'Home', path: '/' },
  { title: 'Analytics', path: '/analytics/overview' },
]);

const OverviewPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Dashboard</PageTitle>

      <Indicators />

      <TrafficEvolutionCard height={500} />

      <div className="row mt-5">
        <div className="col-md-6 d-flex">
          <TopPagesCard />
        </div>
        <div className="col-md-6 d-flex">
          <TopReferrerCard />
        </div>
      </div>

      <TrafficRepartitionCard height={300} />

      <EnvironmentWrapper />
    </>
  );
}

export default OverviewPage;
